import { useEffect, useState } from 'react'

const useMediaQuery = () => {
  const pcWidth = 1200
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= pcWidth)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= pcWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return { isMobile }
}

export default useMediaQuery
